import { rem } from 'polished'

import { styled } from '../../theme'
import { colors } from '../../theme/colors'
import { font } from '../../theme/font'

export const Wrapper = styled.div`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  position: relative;
  max-height: ${rem(65)};
  min-height: ${rem(60)};
  height: ${p => rem(p.theme.controls.height)};
  width: 100%;
  align-content: flex-start;
  justify-items: center;

  overflow-x: hidden; /*horizontal scroll*/
  overflow-y: hidden;

  border: none;
`

export const OptionWrapper = styled.label.attrs({})<{ isSelected: boolean }>`
  display: flex;
  position: relative;
  flex-grow: 1;
  flex-basis: ${rem(60)};
  height: 100%;
  justify-content: center;
  align-content: center;
  align-items: baseline;

  border-left: ${rem(1)} solid ${colors.primary};
  border-right: ${rem(1)} solid ${colors.primary};
  border-bottom: ${rem(1)} solid ${colors.primary};

  background-color: ${p => (p.isSelected ? colors.primary : colors.white)};

  cursor: pointer;
  z-index: 1;
`

export const OptionLabel = styled.span.attrs({})<{ isSelected: boolean }>`
  position:absolute;
  flex-wrap: wrap;
  align-self: center;
  text-align: center;
  height: 100%;
  padding-top: 20px;
  border:none;
  ${font.s()}
    background-color: ${p => (p.isSelected ? colors.primary : colors.white)};
    color: ${p => (p.isSelected ? colors.white : colors.primary)};
    
    z-index: 2;
`

export const OptionContent = styled.input`
  flex-wrap: wrap;
  height: 100%;
  width: 100%;
  background: transparent;
  opacity: 0;
  margin: 0;

  cursor: pointer;
  z-index: 3;
`
